// API Cache utility to prevent duplicate API calls
class ApiCache {
    constructor() {
        this.cache = new Map();
        this.cacheExpiry = 5 * 60 * 1000; // 5 minutes
    }

    // Get cached data if valid
    get(key) {
        const cached = this.cache.get(key);
        if (cached && (Date.now() - cached.timestamp) < this.cacheExpiry) {
            console.log(`Using cached data for ${key}`);
            return cached.data;
        }
        return null;
    }

    // Set cached data
    set(key, data) {
        console.log(`Caching data for ${key}`);
        this.cache.set(key, {
            data,
            timestamp: Date.now()
        });
    }

    // Clear specific cache entry
    clear(key) {
        this.cache.delete(key);
    }

    // Clear all cache
    clearAll() {
        this.cache.clear();
    }

    // Check if cache is valid
    isValid(key) {
        const cached = this.cache.get(key);
        return cached && (Date.now() - cached.timestamp) < this.cacheExpiry;
    }
}

// Export singleton instance
export const apiCache = new ApiCache();